import React from "react";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useChatbotStore = create(
    persist(
        (set) => ({
            anchorEl: null,
            setAnchorEl: (value) => set({ anchorEl: value }),
            reset: () => {
                set({ anchorEl: null });
            },
        }),
        {
            name: "anchor-el-chatbot", // name of the item in the storage (must be unique)
            storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
        }
    )
);

export const withZStore = (BaseComponent) => (props) => {
    const store = useChatbotStore();
    return <BaseComponent {...props} store={store} />;
};
